import{DASH_HANDLER_ID as r}from"../constants";export var isDashHandler=function(t){return t.getId()===r};